import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Menu, Segment } from 'semantic-ui-react';
import { useAuth } from '../../contexts/AuthContext';

function Footer() {
  const { user, logout } = useAuth();

  return (
    <Segment inverted vertical style={{ margin: '5em 0em 0em', padding: '5em 0em' }}>
      <Container textAlign="center">
        <Menu inverted secondary stackable>
          <Menu.Item as={Link} to="/privacy">
            Privacy Policy
          </Menu.Item>
          {user ? (
            <>
          <Menu.Item as={Link} to="/settings">
            Settings
          </Menu.Item>
          <Menu.Item as={Link} to="/delete-account">
            Delete Account
          </Menu.Item>
          </>
          ) : (
            <Menu.Item as={Link} to="/auth">
              Sign In
            </Menu.Item>
          )}
        </Menu>
        <p>© {new Date().getFullYear()} Miakara Soap Recipes. All rights reserved.</p>
      </Container>
    </Segment>
  );
}

export default Footer; 